<script setup>
import { defineProps, defineEmits} from "vue";
import CartaoDePedidoDeCompra from "./CartaoDePedidoDeCompra/CartaoDePedidoDeCompra.vue";
import NovoFollowUpCartao from "./NovoFollowUp/NovoFollowUpCartao.vue";
import FornecedorCartao from "./Fornecedor/FornecedorCartao.vue";
import TabelaDeItens from "./Itens/ItensTabela.vue";
import TabelaDeParcelas from "./Parcelas/ParcelasTabela.vue";
import TabelaFollowUps from "./TabelaFollowUps/TabelaFollowUps.vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "pedidoDeCompra",
    "followUp",
    "controlesDesativados"
]);

const emits = defineEmits([
    "update:followUp"
]);

//==================================================================//
//========================= Altera FollowUp ===========================//
//==================================================================//

const alteraFollowUp = (update) =>{

    emits('update:followUp',update);

}

</script>

<template>

    <div class="c-conteudo">

        <CartaoDePedidoDeCompra
            :dado="pedidoDeCompra"
        ></CartaoDePedidoDeCompra>

        <FornecedorCartao
            :pedidoDeCompra="pedidoDeCompra"
        ></FornecedorCartao>

        <NovoFollowUpCartao
            :followUp="followUp"
            :controlesDesativoados="controlesDesativados"
            @update:followUp="alteraFollowUp"
        ></NovoFollowUpCartao>

        <TabelaDeItens
            :pedidoDeCompra="pedidoDeCompra"
        ></TabelaDeItens>

        <TabelaDeParcelas
            :pedidoDeCompra="pedidoDeCompra"
        ></TabelaDeParcelas>

        <TabelaFollowUps
            :pedidoDeCompra="pedidoDeCompra"
        ></TabelaFollowUps>

    </div>

</template>

<style scoped>

.c-conteudo{
    display: grid;
    gap: 15px;
}

</style>